import React from 'react';
import { CheckCircle } from 'lucide-react'; // Import the CheckCircle icon

const PaymentStatus = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 style={{ color: "green" }}>
        <CheckCircle
          style={{
            display: 'inline-block',
            marginRight: '10px',
            verticalAlign: 'middle',
            width: '48px',  // Increased size
            height: '48px', // Increased size
          }}
        />
        Order Placed Successfully!
      </h1>
      <p>Thank you for your purchase.</p>
    </div>
  );
};

export default PaymentStatus;